import { ReactElement } from 'react';

import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { LoadingBar, StyledContentLayout } from '@/components';

import { CompanyProfileForm } from '../components';
import { useCompanyProfileForm, useGetCompanyProfile } from '../hooks';

export const CompanyProfile = (): ReactElement => {
  const form = useCompanyProfileForm();

  const { isLoading } = useGetCompanyProfile({ reset: form.reset });

  if (isLoading) return <LoadingBar />;

  return (
    <Box bgcolor="#FFF" height="100%">
      <StyledContentLayout fixedHeight>
        <FormProvider {...form}>
          <CompanyProfileForm />
        </FormProvider>
      </StyledContentLayout>
    </Box>
  );
};
